
<style lang="less" scoped>
@import "speakers.less";
</style>
<template>
  <div class="speakerlist_box">
    <!-- <h1><span>演讲嘉宾</span></h1> -->
    <div class="loading" v-if="isLoading"><img src="../../assets/images/loading.gif" alt=""></div>
    <div class="content" v-else>
      <!-- <p class="notice" v-if="$i18n.locale === 'zh'">* 点击查看详情可预约嘉宾</p> -->
      <div class="speaker_box" v-for="speaker in speakerList" :key="speaker.id" @click="showPop(speaker.id)">
        <div class="speaker_img"><img :src="speaker.photo_url" alt=""></div>
        <div class="speaker_intro">
          <p class="name">{{speaker.name}}</p>
          <p class="company">{{speaker.company}}</p>
          <p class="title">{{speaker.title}}</p>
        </div>
      </div>
    </div>
    <div class="speakerPop" v-show="isPopShow">
      <div class="gray" @click="closePop"></div>
      <div class="pop">
        <div class="closediv" @click="closePop"><img src="../../assets/images/popupclose.svg"><div><hr></div></div>
        <div class="scontent">
          <div class="speak-title-div">
            <div class="image-col">
              <img :src="speakerInfo.photo_url">
            </div>
            <div class="text-col">
              <p class="name-box">{{speakerInfo.name}}</p>
              <p class="company-box">{{speakerInfo.company}}</p>
              <p class="title-box">{{speakerInfo.title}}</p>
            </div>
          </div>
          <div class="speak-intro-div">
            <p v-html="speakerInfo.intro"></p>
          </div>
          <!-- <div class="contact" v-if="$i18n.locale === 'zh'">申请交流</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      speakerList: [],
      isLoading: true,
      speakerInfo: {},
      isPopShow: false
    }
  },
  created () {
    this.getSpeakerList()
  },
  watch: {
    '$i18n.locale': {
      handler: function (newer, older) {
        this.getSpeakerList()
      },
      deep: true // 开启深度监听
    }
  },
  methods: {
    getSpeakerList: function () {
      let self = this
      let lang = 'zh-cn'
      if (self.$i18n.locale === 'zh') {
        lang = 'zh-cn'
      } else {
        lang = 'en-us'
      }
      self.$http.get('https://goapi.gmic.cn/api/v1/speakers?lang=' + lang)
        .then(function (res) {
          // console.log(res)
          let speakers = JSON.parse(res.data.data)
          self.speakerList = speakers
          self.isLoading = false
        })
        .catch(function (err) {
          console.log(err)
        })
    },
    showPop: function (id) {
      let self = this
      let lang = 'zh-cn'
      if (self.$i18n.locale === 'zh') {
        lang = 'zh-cn'
      } else {
        lang = 'en-us'
      }
      self.$http.get('https://api.gwcevents.com/' + lang + '/speaker/GetSpeakerById?speakerid=' + id)
        .then(function (res) {
          self.speakerInfo = res.data.result.speakers[0]
          self.isLoading = false
          document.body.style.overflowY = 'hidden'
          self.isPopShow = true
        })
        .catch(function (err) {
          console.log(err)
        })
    },
    closePop: function () {
      document.body.style.overflowY = 'auto'
      this.isPopShow = false
      this.speakerInfo = {}
    }
  },
  destroyed: function () {
    this.closePop()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/speakers/speakers.vue